import axios from '../../../axiosInstance';

export const fetchStagesDropdownValues = () => {
  return axios
    .get('/api/stages/drop_down', {
      withCredentials: true,
    })
    .catch((err) => console.log(err));
};

export const fetchActionsDropdownValues = () => {
  return axios
    .get('/api/action_types/drop_down', {
      withCredentials: true,
    })
    .catch((err) => console.log(err));
};

// export const fetchSubFormsDropdownValues = () => {
//   return axios.get(`${API_URL}/subforms`, {
//   });
// };

export const fetchSubFormsDropdownValues = async () => {
  try {
    const response = await axios
      .get(
        // eslint-disable-next-line no-undef
        `${process.env.REACT_APP_SERVER_URL}/api/subforms/drop_down/drop_down`,
        { withCredentials: true }
      )
      .catch((err) => console.log(err));

    return response;
  } catch (error) {
    console.log('fetchSubFormsDropdownValuesError', error);
  }
};

// export const fetchDropdownValues = async () => {
//   const response = await axios.get(`${API_URL}/api/dropdowns`);
//   return response.data;
// };
